import { render } from "./options.vue?vue&type=template&id=0c8fe9f7&scoped=true"
import script from "./options.vue?vue&type=script&lang=js"
export * from "./options.vue?vue&type=script&lang=js"

import "./options.vue?vue&type=style&index=0&id=0c8fe9f7&scoped=true&lang=css"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c8fe9f7"]])

export default __exports__